/**
 * Module dependencies
 */
const React = require('react');
const { hydrate } = require('nordic/hydrate');
const { AndesProvider } = require('@andes/context');
const AddressesHubView = require('../pages/addresses-hub/view');
require('./polyfills');

/**
 * Get server state
 */
const props = window.__PRELOADED_STATE__;

/**
 * Mount AddressesHubView on client
 */
hydrate(
  <AndesProvider csrfToken={props.csrfToken} locale={props.locale} device={props.device}>
    <AddressesHubView {...props} />
  </AndesProvider>,
  document.getElementById('root-app'),
);
